import {
  ScheduleCompletionActions,
  ScheduleEntryState,
  Task,
  TaskType,
  Timestamp,
  UpdateTask,
} from '@griply/types';

import { computeHabitEntryUpdate } from './compute-habit-entry-update';
import { isNumber } from './is-number';
import { getActiveSchedule } from './schedules/get-active-schedule';

export type CompleteTaskForTodayOptions = {
  today: Timestamp;
  referenceDate?: Timestamp;
  type?: ScheduleEntryState;
  value?: number;
  increment?: number;
  toggleDayEntry?: boolean;
};

export enum CompleteTaskForTodayResultKind {
  Update = 'update',
  ManualEntryRequired = 'manual-entry-required',
  Ignored = 'ignored',
}

export type CompleteTaskForTodayResult =
  | { kind: CompleteTaskForTodayResultKind.Update; update: UpdateTask }
  | { kind: CompleteTaskForTodayResultKind.ManualEntryRequired }
  | { kind: CompleteTaskForTodayResultKind.Ignored };

export const completeTaskForToday = (
  task: Task,
  options: CompleteTaskForTodayOptions,
): CompleteTaskForTodayResult => {
  const {
    today,
    referenceDate,
    type = ScheduleEntryState.Complete,
    value,
    increment,
    toggleDayEntry,
  } = options;

  if (task.type === TaskType.Task) {
    return {
      kind: CompleteTaskForTodayResultKind.Update,
      update: {
        id: task.id,
        completedAt: task.completedAt ? null : referenceDate ?? new Date(),
      },
    };
  }

  const activeSchedule = getActiveSchedule(task.schedules, today);
  if (
    activeSchedule?.action?.type ===
      ScheduleCompletionActions.LogCompletionValue &&
    !isNumber(value) &&
    !isNumber(increment)
  ) {
    return { kind: CompleteTaskForTodayResultKind.ManualEntryRequired };
  }

  const { newSchedules, ignored } = computeHabitEntryUpdate(
    task,
    referenceDate ?? new Date(),
    { today, type, value, increment, toggle: toggleDayEntry },
  );

  if (ignored) {
    return { kind: CompleteTaskForTodayResultKind.Ignored };
  }

  return {
    kind: CompleteTaskForTodayResultKind.Update,
    update: { id: task.id, schedules: newSchedules },
  };
};
